export default __webpack_public_path__ + "static/media/4.addc8148.png";